export default __webpack_public_path__ + "static/media/2027.acab1d31.png";